import type { FC } from 'react';
import type { Banner, DefaultCmsDataResponse } from '@/api/cms/types';
import CooperateCustomers from '@/components/CooperateCustomers';
import Container from '@/components/layouts/Container';
import MoreInfo from '@/components/MoreInfo';
import HelpFormContent from '@/modules/customer/HelpFormContent';
import BenefitsContent from '../../BenefitsContent';
import {
  cooperateFulfillmentData,
  fulfillmentBenefitsData,
  fulfillmentFeaturesData,
} from '../cooperateData';
import CooperateFeatures from '../CooperateFeatures';
import CooperateServiceForm from '../CooperateServiceForm';
import CooperateWarehouseFulfillBanner from '../CooperateWarehouseFulfillBanner';
import FulfillmentWarehouseImg from './FulfillmentWarehouseImage';

type Props = {
  // Declare FulfillmentPage props
  homeBannerData?: DefaultCmsDataResponse<Banner>;
};

export const FulfillmentPage: FC<Props> = ({ homeBannerData }) => {
  const bannerDesktop: string =
    homeBannerData?.attributes?.items
      ?.filter((item) => item.type === 'home' && item.desktop_image)
      .map((item) => ({
        url: item.desktop_image?.data?.attributes?.url,
      }))[0].url || '';

  return (
    <Container
      title="Fulfillment - Giải pháp lưu kho, xử lý đơn hàng kết hợp giao hàng"
      description="Dịch vụ Fulfillment tại Ahamove, giải pháp lưu kho, xử lý đơn hàng kết hợp giao hàng nội thành: Đa dạng nhiệt độ kho, nhanh chóng, đáp ứng đủ nhu cầu"
      image_url={bannerDesktop}
    >
      <main className="mt-header-mobile desktop:mt-header-desktop min-h-content flex w-full grow flex-col">
        <CooperateWarehouseFulfillBanner
          title="Giải pháp lưu kho, xử lý đơn hàng kết hợp giao hàng nhanh nội thành"
          img="/static/images/service/banner-fulfillment.webp"
          type="fulfillment"
          href="/service/cooperate/fulfillment/#registation-form"
        />
        <CooperateCustomers
          items={cooperateFulfillmentData}
          title="Đối tác thân thiết"
          cols="4"
        />
        <BenefitsContent
          title="Hệ thống kho bãi đa dạng"
          desc="Ahamove cung cấp giải pháp lưu kho và hệ thống xử lý đơn hàng hiện đại, giúp bạn yên tâm bảo quản hàng hoá."
          items={fulfillmentBenefitsData}
          type="benefit"
          className="bg-primary-10"
        >
          <MoreInfo
            title="Xem thêm chính sách dịch vụ"
            type="secondary"
            href="/policy"
          />
        </BenefitsContent>
        <CooperateFeatures
          items={fulfillmentFeaturesData}
          img="/static/images/service/features-fulfillment.webp"
        />
        <FulfillmentWarehouseImg />
        <HelpFormContent
          form={<CooperateServiceForm type="service" service="fulfillment" />}
          id="registation-form"
        />
      </main>
    </Container>
  );
};
